const checkUserHasAccount = (userData) => {
  return userData && userData.user_account_info && Object.keys(userData.user_account_info).length > 0
}

// Effective access is authoritative even when actual billing or a trial is paid.
const effectiveAccessTier = (userData) => {
  const tier = userData?.effective_access_tier;
  if (["free", "pro", "max"].includes(tier)) return tier;
  if (userData?.max_trial_active) return "max";
  if (userData?.has_premium_access || userData?.has_active_subscription) {
    return userData?.subscription_plan_tier === "max" ? "max" : "pro";
  }
  return "free";
};

const checkUserHasPremiumAccess = (userData) => effectiveAccessTier(userData) !== "free";
const checkUserHasSubscription = (userData) =>
  checkUserHasAccount(userData) && checkUserHasPremiumAccess(userData);
const checkUserHasMaxAccess = (userData) => effectiveAccessTier(userData) === "max";

export {
  effectiveAccessTier,
  checkUserHasAccount,
  checkUserHasMaxAccess,
  checkUserHasPremiumAccess,
  checkUserHasSubscription,
}
